import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  FloatingLabel,
  Form,
  // NavDropdown,
  OverlayTrigger,
  Row,
  Spinner,
  Tooltip,
} from "react-bootstrap";
import Modal2 from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import { BiBadgeCheck } from "react-icons/bi";
import { GoProject } from "react-icons/go";
import { GrUserExpert } from "react-icons/gr";
import { MdOutlineLanguage } from "react-icons/md";
import Modal from "react-modal";
import { useLocation, useNavigate } from "react-router-dom";
import { vasthuUrl } from "../component/Api";
import BillDeskPay from "../component/BillDeskPay";
import Toast from "../component/Toast";
// import FeedBack from "../component/FeedBack";
import FreeUsed from "../component/FreeUsed";
// import validator from "validator";
import HelmetSeo from "../component/HelmetSeo";
import ReviewBadge from "../component/ReviewBadge";
import UserDetailModal from "../component/UserDetailModal";
import { UseConsultant } from "../context/ConsultantContext";

const OurCallServices = ({ type, action }) => {
  const {
    setAlertFunction,
    chatAlertCall,
    handleWalletCall,
    handleFreeCall,
    walletBalance,
    setWalletBalance,
  } = UseConsultant();
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const lang = window.localStorage.getItem("i18nextLng");
  const userId = window.sessionStorage.getItem("userId");
  const datas = window.sessionStorage.getItem("datas");
  const token = window.sessionStorage.getItem("token");
  const consultantId = window.sessionStorage.getItem("consultantId");
  // const consultantRate = window.sessionStorage.getItem("consultantRate");
  const duration = window.sessionStorage.getItem("AudioCallDuration");
  const uuid = window.sessionStorage.getItem("userId");
  // const authname = window.sessionStorage.getItem("authname");

  // const WalletAmount = JSON.parse(
  //   window.sessionStorage.getItem("WalletAmount")
  // );
  const consultantType = sessionStorage.getItem("consultantType");
  const details =
    location && location.state
      ? location.state
      : type
        ? type
        : consultantType
          ? consultantType
          : "Wallet";
  console.log("details", details);
  console.log("location", location.state);
  console.log("type", type);
  console.log("consultantType", consultantType);
  console.log("action", action);
  const [allLang, setAllLang] = useState([]);
  const [allSkill, setAllSkill] = useState([]);
  const [initialProf, setInitialProf] = useState([]);
  const [profList, setProfList] = useState([]);
  const [searchLang, setSearchLang] = useState("All");
  const [searchSkill, setSearchSkill] = useState("Astrology Consultation");
  const [selectedSkill, setSelectedSkill] = useState("Astrology Consultation");
  console.log("searchSkill", searchSkill);
  console.log("searchSkill selectedSkill", selectedSkill);
  const [searchField, setSearchField] = useState("");
  const [loading, setLoading] = useState(false);
  const [callStatusPro, setCallStatusPro] = useState();
  const [waitingTime, setWaitingTime] = useState();
  const [consulName, setConsulName] = useState();
  const [consulRatePer, setConsulRatePer] = useState();
  const [selectedConsultant, setSelectedConsultant] = useState();
  const [selectedConsultantService, setSelectedConsultantService] = useState();
  const [defaultAudioOffer, setDefaultAudioOffer] = useState({});
  const [defaultAudioOffer15, setDefaultAudioOffer15] = useState({});
  const [defaultAudioOffer30, setDefaultAudioOffer30] = useState({});
  const [freeCallStatus, setFreeCallStatus] = useState("");
  const [bookingStatus, setBookingStatus] = useState("");
  console.log("consulName", consulName);
  const [bookStatusData, setBookStatusData] = useState([]);
  console.log("bookStatusData", bookStatusData);
  const [loadingId, setLoadingId] = useState(null);

  console.log("callStatusPro", callStatusPro);

  console.log("consultantId", consultantId);
  //Modal - active list
  let subtitle;
  const [selectedAudioOffer, setSelectedAudioOffer] = useState(7);
  const [activeServiceList, setActiveServiceList] = useState([]);
  const [serviceData, setServiceData] = useState([]);

  const [consultantServiceList, setConsultantServiceList] = useState([]);

  const [formData, setFormData] = useState({
    duration: 0,
    price: 0,
  });

  //Consultant busy MODA
  const [toast, setToast] = useState(false);

  const closeTosastBtn = () => {
    setToast(false);
  };

  //Check Booking Status
  const [bookStatus, setBookStatus] = useState(false);

  const openBookStatus = () => {
    setBookStatus(true);
  };

  const closeBookStatus = () => {
    setBookStatus(false);
  };

  //Call Duration MODAL
  const [modalIsOpen, setIsOpen] = React.useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  //Service MODAL
  const [serviceModal, setServiceModal] = React.useState(false);

  function afterServiceModal() {
    console.log("afterOpenModal");
  }

  function closeServiceModal() {
    setServiceModal(false);
  }

  // ALERT MODAL
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [toastTrigger, setToastTrigger] = useState(0);

  // const alert = (msg) => {
  //   setMessage(msg);
  //   setToastTrigger((prev) => prev + 1);
  // };

  const alert = (msg, type) => {
    setMessage(msg);
    setMessageType(type);
    setToastTrigger((prev) => prev + 1);
  };

  //Free Service Used Modal
  const [usedFreeModal, setUsedFreeModal] = useState(0);

  //Free User Details Modal
  const [userDetailsModal, setUserDetailsModal] = useState(0);

  useEffect(() => {
    setAlertFunction(alert);
  }, [setAlertFunction]);

  // booking - end
  useEffect(() => {
    vasthuUrl
      .get(`offer/defaultIndividualOffer/audio`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        console.log("audiores", res);
        setDefaultAudioOffer({
          offerId: res.data.id,
          offerPrice: res.data.offerPrice,
        });
      })
      .catch((err) => setDefaultAudioOffer({}));

    vasthuUrl
      .get(`offer/defaultIndividualOffer/audio15`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        console.log("audiores15", res);
        setDefaultAudioOffer15({
          offerId: res.data.id,
          offerPrice: res.data.offerPrice,
        });
      })
      .catch((err) => setDefaultAudioOffer15({}));

    vasthuUrl
      .get(`offer/defaultIndividualOffer/audio30`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        console.log("audiores30", res);
        setDefaultAudioOffer30({
          offerId: res.data.id,
          offerPrice: res.data.offerPrice,
        });
      })
      .catch((err) => setDefaultAudioOffer30({}));
  }, []);

  useEffect(() => {
    setLoading(true);
    if (token) {
      try {
        vasthuUrl
          .get(`/vasthu/getvasthuservices`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            console.log("services_list" + res.data);
            let consultations = res.data.filter(
              (obj) => obj.serviceType == "CONSULTATION"
            );
            console.log(
              "services_list_consultaions" + consultations[0].serviceType
            );
            setServiceData(consultations);
          });

        vasthuUrl
          .get(`/info/professional/consultantdetails`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            setProfList(res.data);
            console.log("res.data", res.data);
            setLoading(false);
          });
      } catch (e) {
        alert("SERVER ERROR");
        setMessageType("error");
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    if (userId !== null) {
      try {
        vasthuUrl
          .get(`/vasthu/user/getuserfreecallstatus/${userId}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            setFreeCallStatus(res.data.freeCallUsed);
          });
      } catch (e) {
        console.log("service", e);
      }
    }
  }, [userId]);

  const executePendingAction = () => {
    const pendingAction = sessionStorage.getItem("pendingAction1");

    const consultantId = sessionStorage.getItem("consultantId");
    const consultantName = sessionStorage.getItem("consultantName");
    const consultantRate = sessionStorage.getItem("consultantRate");
    const consultantType = sessionStorage.getItem("consultantType");
    const userId = sessionStorage.getItem("userId");

    if (!pendingAction || !consultantId || !consultantType) return;

    console.log("executing pendingAction:", pendingAction);
    setConsulName(consultantName);

    if (pendingAction === "ConsutantBookServices") {
      getConsutantServices(consultantId);
    } else if (pendingAction === "ConsultantCallServices") {
      if (consultantType === "freeCall" || consultantType === "freeChat") {
        CheckFreeStatus(consultantId, consultantType);
      } else {
        getCallAndChatService(userId, consultantId, consultantType);
      }
    }

    sessionStorage.removeItem("pendingAction1");
  };

  useEffect(() => {
    if (token) {
      executePendingAction();
    }
  }, []);

  const checkLoginAndGetConsultant = (
    id,
    consultantName,
    consultantRate,
    type
  ) => {
    const token = sessionStorage.getItem("token");
    const userId = sessionStorage.getItem("userId");
    const localDetails = type || details;

    setLoadingId(String(id));

    sessionStorage.setItem("consultantId", id);
    sessionStorage.setItem("consultantName", consultantName);
    sessionStorage.setItem("consultantRate", consultantRate);
    sessionStorage.setItem("consultantType", localDetails);

    if (!token) {
      const actionType =
        localDetails === "Book"
          ? "ConsutantBookServices"
          : "ConsultantCallServices";

      sessionStorage.setItem("pendingAction1", actionType);
      sessionStorage.setItem("rerender", location.pathname);

      alert(t("USR.LOG.MSG"));
      setMessageType("error");

      setTimeout(() => {
        setLoadingId(null);
        navigate("/login");
      }, 3000);

      return;
    }

    setConsulName(consultantName);

    if (localDetails === "freeCall" || localDetails === "freeChat") {
      CheckFreeStatus(id, localDetails);
    } else if (
      localDetails === "Duration" ||
      localDetails === "Wallet" ||
      localDetails === "Chat"
    ) {
      getCallAndChatService(userId, id, localDetails);
    } else if (localDetails === "Book") {
      getConsutantServices(id);
    }

    setLoadingId(null);
  };

  const getCallAndChatService = (userId, consultantId, type) => {
    const country = window.sessionStorage.getItem("country");

    try {
      vasthuUrl
        .post(
          `vasthu/check-call-eligibility`,
          {
            userUuid: userId,
            proUuid: consultantId,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          console.log("res.data", res.data);
          if (res.data.status == "INSUFFICIENT_BALANCE") {
            if (res.data.balance == 0) {
              alert(t("USR.INSF.BAL.ALRT.MSG"));
              setMessageType("error");
              window.sessionStorage.setItem("consultantId", consultantId);
              window.sessionStorage.setItem("consultantType", type);
              window.sessionStorage.setItem("returnurl", location.pathname);
              window.sessionStorage.setItem(
                "pendingAction1",
                "ConsultantCallServices"
              );
              setTimeout(() => {
                navigate("/walletoffer");
              }, 3000);
            } else {
              alert(
                `${t("USR.BAL.MINCOST.CONST.ALT")} ₹${res.data.amountNeeded
                }  ${t("USR.THIS.CONSULTANT")}.`
              );
              setMessageType("error");
              window.sessionStorage.setItem("consultantId", consultantId);
              window.sessionStorage.setItem("consultantType", type);
              window.sessionStorage.setItem("returnurl", location.pathname);
              window.sessionStorage.setItem(
                "pendingAction1",
                "ConsultantCallServices"
              );
              setTimeout(() => {
                navigate("/walletoffer");
              }, 3000);
            }
            window.sessionStorage.removeItem("pendingAction1");
            console.log("Clear -> pendingAction1");
          } else if (res.data.message == "NOT A VALID USER") {
            alert(t("USR.INSF.BAL.ALRT.MSG"));
            setMessageType("error");
            setTimeout(() => {
              navigate("/walletoffer");
            }, 3000);
          } else if (res.data.status == "CONSULTANT_IN_CALL") {
            setToast(true);
            setWaitingTime(res.data.expectedToBeFreeInMinutes);
          } else if (res.data.status == "DONT_CALL") {
            setBookingStatus(res.data);
            openBookStatus();
          } else if (res.data.status == "CALL_ALLOWED") {
            if (type == "Duration") {
              console.log("Duration");
              openModal();
            } else if (type == "Wallet") {
              console.log("Wallet");
              if (country == "0") {
                handleWalletCall();
              } else {
                setUserDetailsModal((prev) => prev + 1);
              }
              // handleWalletCall();
            } else if (type == "Chat") {
              console.log("Chat");
              setUserDetailsModal((prev) => prev + 1);
            } else if (type == "freeCall" || type == "freeChat") {
              CheckFreeStatus(consultantId, type);
            }
          }
        });
    } catch (e) {
      console.log("e", e);
    }
  };

  const CheckFreeStatus = async (id, type) => {
    const userId = sessionStorage.getItem("userId");
    const token = sessionStorage.getItem("token");
    const country = window.sessionStorage.getItem("country");

    if (!userId || !token) {
      console.log("User not logged in - skipping CheckFreeStatus");
      return;
    }

    sessionStorage.removeItem("pendingAction1");

    try {
      const res = await vasthuUrl.get(
        `/vasthu/user/getuserfreecallstatus/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const freeCallStatus = res.data.freeCallUsed;
      console.log("freeCallStatus", freeCallStatus);

      if (freeCallStatus) {
        setUsedFreeModal((prev) => prev + 1);
      } else {
        if (type === "freeCall") {
          if (country == "0") {
            handleFreeCall();
          } else {
            setUserDetailsModal((prev) => prev + 1);
          }
        } else if (type === "freeChat") {
          setUserDetailsModal((prev) => prev + 1);
          console.log("freeChat alert call");
        }
      }
    } catch (e) {
      console.error("Error in CheckFreeStatus", e);
    }
  };

  const handleProceed = () => {
    const country = window.sessionStorage.getItem("country");

    if (details == "Chat") {
      setUserDetailsModal((prev) => prev + 1);
    } else {
      if (country == "0") {
        handleWalletCall(); //Limited Duration
      } else {
        setUserDetailsModal((prev) => prev + 1);
      }
    }
    closeBookStatus();
  };

  const getConsutantServices = (uuid) => {
    try {
      vasthuUrl
        .get(`vasthu/getvasthuservicesbyconsultant/${uuid}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setConsultantServiceList(res.data);
          setSelectedConsultant(uuid);
          if (selectedConsultantService == null) {
            setServiceModal(true);
          } else {
            CheckConsultant(uuid);
          }
        });
    } catch (e) {
      console.log("service", e);
    }
  };

  // const CheckConsultant = (uuid) => {
  //   console.log("selectedConsultant", selectedConsultant);
  //   console.log("uuid", uuid);
  //   console.log("profList", profList);
  //   if (typeof selectedConsultantService !== "undefined") {
  //     let value = profList.find(
  //       (x) => x.consultantUuid == (selectedConsultant || uuid)
  //     );
  //     let selectedService = selectedConsultantService;
  //     window.sessionStorage.setItem(
  //       "checkcon",
  //       JSON.stringify({ value, selectedService })
  //     );
  //     console.log("value", value);
  //     navigate("/checkconsultant");
  //   } else {
  //     alert("Please Select a service");
  //     setMessageType("error");
  //   }
  // };

  /**change flow for book click to go offer  **/
  const CheckConsultant = (uuid) => {
    if (typeof selectedConsultantService !== "undefined") {
      let value = profList.find(
        (x) => x.consultantUuid == (selectedConsultant || uuid)
      );
      window.sessionStorage.setItem(
        "consultantDetail",
        JSON.stringify({ value })
      );
      console.log("value", value);
      navigate("/customerpricing", { state: selectedConsultantService });
    } else {
      alert("Please Select a service");
      setMessageType("error");
    }
  };

  const payHandler = (txn) => {
    console.log("pay response out", txn);
    vasthuUrl
      .post(
        "vasthu/user/bdpaymentresponseui",
        { txn: txn.txnResponse.transaction_response },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        console.log("txnres", res.data);

        if (res.data.transaction_error_type === "success") {
          console.log("Saving payment_response ....", txn);

          vasthuUrl
            .post("vasthu/user/bdpaymentresponsehandler", txn, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            })
            .then((res) => console.log("after txnsave", res.data))
            .catch((err) => console.log("after txnsave try", err));

          console.log("buying .. subsc");

          setTimeout(() => {
            vasthuUrl
              .post(
                "subscription/buyVasthuOffer",
                {
                  orderId: res.data.orderid,
                  userUuid: userId,
                  offerId: selectedAudioOffer,
                  paymentStatus: true,
                },
                {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                }
              )
              .then((res) => {
                console.log("Payment status changed to true");
                console.log("call audio");
                console.log("afterbuysubscr", res.data);
                // navigate("/audiocallstart", { state: res.data });
                if (details == "Chat") {
                  navigate("/startchat");
                } else {
                  try {
                    vasthuUrl.post(
                      `vasthu/user/clicktocall`,
                      {
                        from: consultantId, //"09790580304",
                        to: uuid, //"07092758264",
                        duration: parseInt(duration), //30min
                        subscriptionId: res.data.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer ${token}`,
                        },
                      }
                    );
                    console.log("postresponsefrom audio call", res.data);
                    console.log("postresponsefrom audio call", res);
                    if (res.status == 200) {
                      navigate("/audiocallstatus", {
                        state: { callStatus: "USR.CAL.PROCED.BTN" },
                      });
                      // console.log("offerId - on 200 [already register offer] status",i.id)
                      console.log(
                        "offerId - on 200 [already register offer] status",
                        res.data.id
                      );
                      vasthuUrl
                        .get(
                          // `/subscription/useVasthuOffer/${i.id}`,
                          `/subscription/useVasthuOffer/${res.data.id}`,
                          {
                            headers: {
                              Authorization: `Bearer ${token}`,
                            },
                          }
                        )
                        .then((rs) =>
                          console.log(
                            "offer subscription redeem count used",
                            rs.data.message
                          )
                        )
                        .catch((er) =>
                          console.log(
                            "offer subscription redeem count not reduced",
                            er
                          )
                        );
                    } else {
                      navigate("/audiocallstatus", {
                        state: { callStatus: "USR.CAL.FAILD.BTN" },
                      });
                    }
                  } catch (err) {
                    console.log("SERVER ERROR", err);
                  }
                }
              });
          }, 1000);
        } else {
          vasthuUrl
            .post(
              "subscription/buyVasthuOffer",
              {
                orderId: res.data.orderid,
                userUuid: userId,
                offerId: selectedAudioOffer,
                paymentStatus: false,
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            )
            .then((res) => {
              console.log("Payment status changed to false");
            });
        }
      });
  };

  const handleBuy1 = async (e) => {
    try {
      console.log("handle_buy1");
      await vasthuUrl
        .post(
          `vasthu/openapi/createorderapi`,
          {
            userUuid: userId,
            offerId: selectedAudioOffer,
            price: formData.price,
            currency: "356",
            returnUrl: "paymentstatusbilldesk",
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          console.log("billDesk", res.data);
          BillDeskPay(res.data, payHandler)
            .then((config) => {
              console.log("payout", config);
              window.loadBillDeskSdk(config);
            })
            .catch((err) => console.log("payment initialize error", err));
        });
    } catch (err) {
      console.log(err);
    }
  };

  const handlePsumbit1 = async (event) => {
    setLoading(true);
    event.preventDefault();
    try {
      vasthuUrl
        .get(`/subscription/userActiveOffers/${userId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(async (list) => {
          console.log("Audiocall list available " + JSON.stringify(list.data));
          let filteredAudioList = list.data.filter(
            // (obj) => obj.offerId == selectedAudioOffer
            (obj) => obj.offerId > 2
          );
          console.log("filtered audio list", filteredAudioList);
          console.log("filtered audio list len  ", filteredAudioList.length);

          console.log("filtered audio list", list.data);
          console.log("filtered audio list len  ", list.data.length);

          // setActiveServiceList(list.data);
          setActiveServiceList(filteredAudioList);

          // if ((list.data).length > 0) {
          // if (filteredAudioList.length > 0) {
          //   openModal1();
          if (false) {
          } else {
            console.log("no subscription - please proceed with pay");
            setLoading(false);
            handleBuy1();
            closeModal();
          }
        });
    } catch (e) {
      alert("CHECK INTERNET CONNECTION");
      setMessageType("error");
      console.log("error from trying subscription list " + e);
      setLoading(false);
      // console.log("SERVER ERROR", e);
    }
  };

  const handleDurationRadio = (e) => {
    if (e.target.value === "15") {
      window.sessionStorage.setItem("AudioCallDuration", String(900));
      setSelectedAudioOffer(defaultAudioOffer15.offerId);
      setFormData({
        duration: e.target.value,
        price: defaultAudioOffer15.offerPrice,
      });
    } else if (e.target.value === "30") {
      window.sessionStorage.setItem("AudioCallDuration", String(1800));
      setSelectedAudioOffer(defaultAudioOffer30.offerId);
      setFormData({
        duration: e.target.value,
        price: defaultAudioOffer30.offerPrice,
      });
    } else {
      window.sessionStorage.setItem("AudioCallDuration", String(3600));
      setSelectedAudioOffer(defaultAudioOffer.offerId);
      setFormData({
        duration: e.target.value,
        price: defaultAudioOffer.offerPrice,
      });
    }
  };

  useEffect(() => {
    vasthuUrl
      .get(`vasthu/openapi/getskills`)
      .then((res) => {
        setAllSkill(res.data);
        console.log("all skills", res.data);
      })
      .catch((err) => {
        setAllSkill([]);
        alert("can't get Skills");
        setMessageType("error");
      });
    vasthuUrl
      .get("openapi/lang/allCode")
      .then((res) => {
        console.log("available lang", res.data);
        setAllLang(res.data);
      })
      .catch((err) => {
        setAllLang([]);
        alert("can't get lang");
        setMessageType("error");
      });
  }, []);

  useEffect(() => {
    const fetchProfessionalData = async () => {
      setLoading(true);
      console.log("searchSkill", searchSkill);
      try {
        vasthuUrl
          .post(`info/professional/byskillorlang`, {
            skill: searchSkill,
            langCode: searchLang,
          })
          .then((res) => {
            setInitialProf(res.data);
            console.log("res.data", res.data);

            setLoading(false);
            if (searchSkill == "Vasthu Consultation") {
              setSelectedConsultantService(3);
            } else if (searchSkill == "Astrology Consultation") {
              setSelectedConsultantService(4);
            } else if (searchSkill == "Building Consultation") {
              setSelectedConsultantService(5);
            } else {
              setSelectedConsultantService();
            }
            console.log("con filter out", res.data);
          });
      } catch (error) {
        setInitialProf((prev) => prev);
        setLoading(false);
        console.log("consultlist", error);
      }
    };

    fetchProfessionalData();
  }, [searchSkill, searchLang]);

  const filteredPersons = initialProf.filter((person) => {
    return person.consultantName
      .toLowerCase()
      .includes(searchField.toLowerCase());
  });

  const handleChange = (e) => {
    setSearchField(e.target.value);
  };

  const handleLang = (e) => {
    setSearchLang(e.target.value);
  };

  const consultations = [
    {
      src: "expert.png",
      label: "Vasthu",
      value: "Vasthu Consultation",
      id: "vasthu-consultation",
    },
    {
      src: "austrologer.png",
      label: "Astrology",
      value: "Astrology Consultation",
      id: "astrology-consultation",
    },
    {
      src: "architech.png",
      label: "Building",
      value: "Building Consultation",
      id: "building-consultation",
    },
  ];

  const handleOnChange = (e) => {
    setSearchSkill(e.target.value);
    setSelectedSkill(e.target.value);
  };

  return (
    <div className="p-1">
      <HelmetSeo
        title="Talk to a Vedic Astrology & Vasthu Expert | Vasthuparam "
        name="description"
        content="Need instant guidance? Use Vasthuparam Call Services to speak directly with professional Vedic Astrology & Vasthu and astrology experts."
        relCa="canonical"
        hrefCa="https://www.vasthuparam.com/ourcallservices"
        relAl="alternate"
        hrefAl="https://m.www.vasthuparam.com/ourcallservices"
      />
      <Toast msg={message} type={messageType} trigger={toastTrigger} />
      <FreeUsed usedFreeModal={usedFreeModal} walletBalance={walletBalance} />
      <UserDetailModal userDetailsModal={userDetailsModal} />

      <div class="row d-flex justify-content-end align-items-center my-1">
        {details == "Wallet" || details == "Chat" ? (
          <>
            <h4>
              {token !== null ? (
                <b>
                  {t("USR.AVABLE.BALCE")}: ₹ {walletBalance}
                </b>
              ) : null}
            </h4>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h6 className="d-block d-sm-none" style={{ color: "red" }}>
                {t("USR.WALT..BALCE.ALT.MSG")}
              </h6>

              <h4 className="d-none d-sm-block" style={{ color: "red" }}>
                {t("USR.WALT..BALCE.ALT.MSG")}
              </h4>
              <Button
                className="mt-2 all_btn"
                onClick={() => {
                  if (token !== null) {
                    navigate("/walletoffer");
                  } else {
                    window.sessionStorage.setItem("rerender", "walletoffer");
                    navigate("/login");
                  }
                }}
                style={{ float: "right" }}
              >
                {t("USR.RECHARGE")}
              </Button>
            </div>
          </>
        ) : null}

        <div className="p-2 px-3" style={{ display: "flex", gap: "1rem" }}>
          {consultations.map((consultation, index) => (
            <Form.Check
              inline
              label={consultation.label}
              value={consultation.value}
              checked={selectedSkill === consultation.value}
              onChange={handleOnChange}
              name="consultation"
              type="radio"
              id={consultation.id}
              className="slot_check1"
            />
          ))}
        </div>

        <Row className="m-0 p-0 mb-1">
          <Col xs={6}>
            <div class="form">
              <input
                type="text"
                class="form-control form-input form_feild"
                placeholder={t("CM.CNSL.SER.PL")}
                onChange={handleChange}
              />
            </div>
          </Col>

          <Col xs={6}>
            <Form.Select
              value={searchLang}
              className="form_feild"
              onChange={handleLang}
            >
              <option value="ALL">{t("CM.CNSL.ON.SER2")}</option>
              {allLang.map((i) => (
                <option value={i.langCode} key={i.id}>
                  {/* {i.language} */}
                  {lang == "en"
                    ? i.language
                    : lang == "ta"
                      ? i.langTextTa
                      : i.langTextHi}
                </option>
              ))}
            </Form.Select>
          </Col>
        </Row>
      </div>

      {!loading ? (
        <div>
          <Modal2
            show={modalIsOpen}
            onHide={closeModal}
            className="all_border"
            centered
          // isOpen={modalIsOpen}
          // onAfterOpen={afterOpenModal}
          // onRequestClose={closeModal}
          // // style={customStyles}
          // contentLabel="Audio Call Duration"
          >
            <Modal2.Header closeButton className="all_background">
              <h3> {t("USR.AUD.CALL.DURATION")}</h3>
            </Modal2.Header>
            <h3
              className="text-center mt-3"
              ref={(_subtitle) => (subtitle = _subtitle)}
            >
              {t("TXT.SEL.AUD.CAL.DURA.LO")}
            </h3>
            <form onSubmit={handlePsumbit1}>
              <div
                className="text-center"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginBottom: "10px",
                }}
              >
                <div>
                  <label>15 {t("TXT.MIN.LO")}</label>
                  {/*  15 min */}
                  <input
                    type="radio"
                    name="duration"
                    value={15}
                    onChange={handleDurationRadio}
                    style={{ marginLeft: "revert" }}
                  />
                </div>
                <div>
                  <label>30 {t("TXT.MIN.LO")}</label>
                  {/*  30 min */}
                  <input
                    type="radio"
                    name="duration"
                    value={30}
                    onChange={handleDurationRadio}
                    style={{ marginLeft: "revert" }}
                  />
                </div>
                {/* <input type="submit" /> */}
              </div>
              <Modal2.Footer
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  padding: "5px",
                }}
                className="all_border"
              >
                <Button size="sm" type="submit" className="all_btn">
                  {t("USR.VFP.DRP.BTN.SMT")}
                </Button>
                <Button size="sm" onClick={closeModal} className="all_btn">
                  {t("TXT.BTN.CAN.LO")}
                </Button>
              </Modal2.Footer>
            </form>
          </Modal2>

          <Modal
            isOpen={serviceModal}
            onAfterOpen={afterServiceModal}
            onRequestClose={closeServiceModal}
            contentLabel="Select Consultation Service"
          >
            <h2
              className="text-center all_background mt-4"
              ref={(_subtitle) => (subtitle = _subtitle)}
            >
              {t("TXT.SEL.SER.LO")}
            </h2>

            <div
              className="text-center"
              style={{ display: "flex", flexDirection: "column" }}
            >
              <FloatingLabel className="selected_service_radio" controlId="min">
                {consultantServiceList.map((service, index) => (
                  <div key={index} className="radio-item">
                    <Form.Check
                      type="radio"
                      className="slot_check"
                      id={`service_${service.id}`}
                      name="consultantService"
                      value={service.id}
                      onChange={(e) => {
                        console.log(
                          "SelectedConsultationService",
                          e.target.value
                        );
                        setSelectedConsultantService(e.target.value);
                      }}
                    />
                    <label htmlFor={`service_${service.id}`}>
                      {lang === "en"
                        ? service.serviceName
                        : lang === "ta"
                          ? service.serviceNameTamil
                          : service.serviceNameHindi}
                    </label>
                  </div>
                ))}
              </FloatingLabel>

              <Button
                size="sm"
                type="submit"
                className="all_btn"
                style={{ width: "100%", marginTop: "8px" }}
                onClick={CheckConsultant}
              >
                {t("USR.VFP.DRP.BTN.SMT")}
              </Button>
            </div>

            <center>
              <Button
                size="sm"
                style={{ width: "100%", marginTop: "8px" }}
                onClick={closeServiceModal}
                className="all_btn"
              >
                {t("TXT.BTN.CAN.LO")}
              </Button>
            </center>
          </Modal>

          <Modal2
            onHide={() => setToast(false)}
            show={toast}
            className="all_border"
          >
            <Modal2.Header closeButton className="all_background">
              <b>{t("TXT.CON.BSY.LO")}!!!</b>
            </Modal2.Header>
            <Modal2.Body>
              {t("USR.CNST.CL.HLO.TEXT")} &nbsp;
              <b>{consulName}</b> {t("USR.CNST.CL.BUSY.ALT")} {waitingTime}{" "}
              {t("USR.CNST.CL.MIN.TEXT")} &nbsp;
              {t("USR.CNST.CL.LTR.TEXT")}
            </Modal2.Body>
            <Modal2.Footer>
              <Button className="all_btn" onClick={closeTosastBtn}>
                {t("TXT.CLO.LO")}
              </Button>
            </Modal2.Footer>
          </Modal2>

          <Modal2 show={bookStatus} onHide={closeBookStatus}>
            <Modal2.Header className="all_background" closeButton>
              <Modal2.Title>{t("USR.BSY.ALT")}</Modal2.Title>
            </Modal2.Header>
            <Modal2.Body>
              <div>
                {bookingStatus.status === "DONT_CALL" &&
                  bookingStatus.allowedTalkTime > 0 ? (
                  <>
                    {t("USR.THIS.CON.BUSY.TEXT")}{" "}
                    <b>{bookingStatus.allowedTalkTime}</b>{" "}
                    {t("USR.CONS.CALCOMG.MSG")}
                  </>
                ) : (
                  t("USR.DONT.CL.MSG")
                )}
              </div>
            </Modal2.Body>
            <Modal2.Footer className="d-flex justify-content-evenly">
              <Button className="all_btn1" onClick={closeBookStatus}>
                {t("TXT.CLO.LO")}
              </Button>
              {bookingStatus.status == "DONT_CALL" &&
                bookingStatus.allowedTalkTime > 0 ? (
                <Button className="all_btn1" onClick={() => handleProceed()}>
                  {t("USR.BOK.UR.PLN.PRCED")}
                </Button>
              ) : null}
            </Modal2.Footer>
          </Modal2>

          {/* <Container className="mt-2"> */}
          <Row className="d-flex  g-2">
            {filteredPersons.length > 0 ? (
              <>
                {filteredPersons.map((i, j) => (
                  <>
                    {i.professionalAccountStatus === "ACTIVATE" ? (
                      <Col md={6} lg={4}>
                        <Card
                          className="d-flex professionalCard all_border"
                          key={i.consultantUuid}
                        >
                          {/* <Card.Header className="social_con_header all_border"> */}
                          <Card.Header className="all_border">
                            <div className="d-flex justify-content-between flex-row">
                              <strong>{i.consultantName}</strong>
                              <span
                                style={{
                                  width: "max-content",
                                  cursor: "pointer",
                                }}
                              >
                                <ReviewBadge
                                  conUuid={i.consultantUuid}
                                  conName={i.consultantName}
                                  conImgUrl={i.imgUrl}
                                  conRating={i.consultantRating}
                                />
                              </span>
                            </div>

                            <div
                              className="mt-2 gap-1"
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div>
                                {i.imgUrl ? (
                                  <img
                                    src={i.imgUrl}
                                    style={{
                                      borderRadius: "50%",
                                      height: "50px",
                                      width: "50px",
                                      objectFit: "cover",
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={require("../images/noimage.jpg")}
                                    style={{
                                      borderRadius: "50%",
                                      height: "50px",
                                      width: "50px",
                                      objectFit: "cover",
                                    }}
                                  />
                                )}
                              </div>

                              <div
                                sm={9}
                                style={{
                                  textAlign: "left",
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <small
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <MdOutlineLanguage />
                                  {i.knownLangugae},{i.extraLang}
                                </small>
                                <small
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <BiBadgeCheck />
                                  {i.skills},{i.extraSkill}
                                </small>
                                <small>
                                  <GrUserExpert />
                                  {i.expYear}
                                  {t("USR.HOM.CL.TEXT1")}
                                </small>
                                {i.profstatus === 1 &&
                                  !freeCallStatus &&
                                  i.freeCallMins > 0 &&
                                  i.freeCallAccess ? (
                                  <small
                                    style={{
                                      color: "green",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {details === "Wallet" ? (
                                      <>
                                        <span>{t("USR.FREE")}</span>

                                        <OverlayTrigger
                                          key="top"
                                          placement="top"
                                          overlay={
                                            <Tooltip id={`tooltip-top`}>
                                              <span>
                                                {i.freeCallMins}&nbsp;
                                                {t("USR.MIN.FREE")}{" "}
                                              </span>
                                            </Tooltip>
                                          }
                                        >
                                          <u
                                            style={{
                                              margin: "0px 5px",
                                              cursor: "pointer",
                                            }}
                                            onClick={() => {
                                              checkLoginAndGetConsultant(
                                                i.consultantUuid,
                                                i.consultantName,
                                                i.ratePerMin,
                                                "freeCall"
                                              );
                                            }}
                                          >
                                            {t("TXT.CAL.LO")}{" "}
                                          </u>
                                        </OverlayTrigger>
                                      </>
                                    ) : details === "Chat" ? (
                                      <>
                                        <span> {t("USR.FREE")}</span>
                                        {i.consultantUuid ==
                                          "8cbd80ed-07ae-4925-aff7-3f34470ea09d" ||
                                          i.consultantUuid ==
                                          "d187f6a9-28f4-4dc8-89d8-52f464679633" ||
                                          i.consultantUuid ==
                                          "7357db37-2061-4956-869f-889c9259b6d5" ? null : (
                                          <OverlayTrigger
                                            key="top"
                                            placement="top"
                                            overlay={
                                              <Tooltip id={`tooltip-top`}>
                                                <span>
                                                  {i.freeCallMins}&nbsp;
                                                  {t("USR.MIN.FREE")}{" "}
                                                </span>
                                              </Tooltip>
                                            }
                                          >
                                            <u
                                              style={{
                                                margin: "0px 5px",
                                                cursor: "pointer",
                                              }}
                                              onClick={() => {
                                                checkLoginAndGetConsultant(
                                                  i.consultantUuid,
                                                  i.consultantName,
                                                  i.ratePerMin,
                                                  "freeChat"
                                                );
                                              }}
                                            >
                                              {t("USR.CHAT.BTN")}
                                            </u>
                                          </OverlayTrigger>
                                        )}
                                      </>
                                    ) : null}
                                  </small>
                                ) : null}
                              </div>
                            </div>
                          </Card.Header>
                          <div>
                            <Row
                              style={{
                                // display: "inline-grid",
                                marginBottom: "6px",
                              }}
                            >
                              {details == "Duration" ? (
                                <center>
                                  <OverlayTrigger
                                    key="top"
                                    placement="top"
                                    overlay={
                                      <Tooltip id={`tooltip-top`}>
                                        {t("TXT.STA.CALL.LO")}
                                      </Tooltip>
                                    }
                                  >
                                    <Button
                                      className="mt-2 all_btn"
                                      size="sm"
                                      disabled={
                                        i.profstatus === 1 ? false : true
                                      }
                                      onClick={() => {
                                        checkLoginAndGetConsultant(
                                          i.consultantUuid,
                                          i.consultantName
                                        );
                                      }}
                                    >
                                      {t("USR.HOM.CL.ACTION1")}
                                    </Button>
                                  </OverlayTrigger>
                                </center>
                              ) : details == "Book" ? (
                                <center>
                                  <OverlayTrigger
                                    key="top"
                                    placement="top"
                                    overlay={
                                      <Tooltip id={`tooltip-top`}>
                                        {t("TXT.DO.SCH.LO")}
                                      </Tooltip>
                                    }
                                  >
                                    <Button
                                      className="mt-2 all_btn"
                                      size="sm"
                                      disabled={
                                        i.profstatus === 1 ? false : true
                                      }
                                      onClick={() => {
                                        checkLoginAndGetConsultant(
                                          i.consultantUuid,
                                          i.consultantName
                                        );
                                      }}
                                    >
                                      {t("USR.HOM.CL.ACTION2")}
                                    </Button>
                                  </OverlayTrigger>
                                </center>
                              ) : null}
                            </Row>
                          </div>
                          <div>
                            <Row
                              style={{
                                textAlign: "center",
                                alignItems: "baseline",
                              }}
                            >
                              <Col>
                                {details === "Wallet" || details == "Chat" ? (
                                  <div>
                                    <b>
                                      <span>₹{i.ratePerMin}</span>&nbsp;
                                    </b>
                                    <del style={{ color: "red" }}>
                                      {i.maxRate == 0
                                        ? null
                                        : `${i.maxRate}/${t("TXT.MIN.LO")}`}
                                    </del>
                                  </div>
                                ) : null}
                              </Col>

                              <Col>
                                {details == "Wallet" ? (
                                  <>
                                    <OverlayTrigger
                                      key="top"
                                      placement="top"
                                      overlay={
                                        <Tooltip id={`tooltip-top`}>
                                          {t("TXT.STA.CALL.LO")}
                                        </Tooltip>
                                      }
                                    >
                                      <Button
                                        className="mt-2 mb-2 all_btn"
                                        size="sm"
                                        disabled={
                                          i.profstatus === 1 ? false : true
                                        }
                                        onClick={() => {
                                          checkLoginAndGetConsultant(
                                            i.consultantUuid,
                                            i.consultantName,
                                            i.ratePerMin
                                          );
                                          console.log(
                                            "i.ratePerMin",
                                            i.ratePerMin
                                          );
                                        }}
                                      >
                                        {/* <button onClick={() => GetWelletService(userId, 5)}>Start 5-minute Call</button> */}
                                        {/* <AiFillSchedule size={25} /> */}
                                        {t("USR.HOM.CL.ACTION1")}
                                      </Button>
                                    </OverlayTrigger>
                                    {/* </div> */}
                                  </>
                                ) : details == "Chat" ? (
                                  <div>
                                    {i.consultantUuid ==
                                      "8cbd80ed-07ae-4925-aff7-3f34470ea09d" ||
                                      i.consultantUuid ==
                                      "d187f6a9-28f4-4dc8-89d8-52f464679633" ||
                                      i.consultantUuid ==
                                      "7357db37-2061-4956-869f-889c9259b6d5" ? null : (
                                      <OverlayTrigger
                                        key="top"
                                        placement="top"
                                        overlay={
                                          <Tooltip id={`tooltip-top`}>
                                            {t("USR.START.CHAT")}
                                          </Tooltip>
                                        }
                                      >
                                        <Button
                                          className="mt-2 mb-2 all_btn"
                                          size="sm"
                                          disabled={
                                            i.profstatus === 1 ? false : true
                                          }
                                          onClick={() => {
                                            checkLoginAndGetConsultant(
                                              i.consultantUuid,
                                              i.consultantName,
                                              i.ratePerMin
                                            );
                                          }}
                                        >
                                          {String(loadingId) ===
                                            String(i.consultantUuid) && (
                                              <span className="spinner-border spinner-border-sm me-2"></span>
                                            )}
                                          {t("USR.CHAT.BTN")}
                                        </Button>
                                      </OverlayTrigger>
                                    )}
                                  </div>
                                ) : null}
                              </Col>
                            </Row>
                          </div>
                          {i.profstatus === 1 ? (
                            <Card.Footer
                              className="text-center all_border"
                              style={{ color: "green", height: 45 }}
                            >
                              <strong>{t("USR.HOM.PR.ONL")}</strong>
                              &nbsp;
                              <Spinner
                                animation="grow"
                                variant="success"
                                size="sm"
                              />
                              {/* <GoProject color="RED" size={20} /> */}
                            </Card.Footer>
                          ) : null}
                          {i.profstatus === 2 ? (
                            <Card.Footer
                              className="text-center all_border"
                              style={{ color: "red", height: 45 }}
                            >
                              <strong>{t("USR.HOM.PR.OFF")}</strong>
                              &nbsp;
                              <GoProject color="RED" size={20} />
                            </Card.Footer>
                          ) : null}
                          {i.profstatus === 3 ? (
                            <Card.Footer
                              className="text-center all_border"
                              style={{ color: "green", height: 45 }}
                            >
                              <strong>{t("USR.HOM.PR.ONCA")}</strong>
                              &nbsp;
                              <Spinner
                                animation="grow"
                                variant="success"
                                size="sm"
                              />
                            </Card.Footer>
                          ) : null}
                        </Card>
                      </Col>
                    ) : null}
                  </>
                ))}
              </>
            ) : (
              <center>
                <h5>{t("USR.NO.CONSLT")}</h5>
              </center>
            )}
          </Row>
          {/* </Container> */}
        </div>
      ) : (
        <center>
          <Spinner animation="border" />
        </center>
      )}
    </div>
  );
};

export default OurCallServices;
